import appFineReimbursement from "../../views/appPlans/fineReimbursementView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("finereimbursement", {
    url: "fine-reimbursement/:id",
    parent: "app",
    views: {
      view: {
        template: appFineReimbursement,
      },
    },
    reloadOnSearch: false,
    data: { title: "FineReimbursement" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/fineReimbursement.urls.js